import React from "react";
import { connect } from "react-redux";
import { StripeProvider, Elements } from "react-stripe-elements";
import PaymentForm from "components/v3/payment-form/PaymentForm";
import paymentFormActions from "ducks/paymentForm";
import { PAYMENT_METHODS, STRIPE_FONTS_URL } from "common/constants/Constants";
import appConfig from "utils/appConfig";

class PaymentFormContainer extends React.Component {
    componentDidMount() {
        if (!this.props.paymentMethod) {
            this.props.setPaymentMethod(PAYMENT_METHODS.STRIPE);
        }
    }

    render() {
        const { stripePublicKey, paypalEnv } = appConfig();

        return (
            <StripeProvider apiKey={ stripePublicKey }>
                <Elements fonts={ [{ cssStr: STRIPE_FONTS_URL }] }>
                    <PaymentForm
                        { ...this.props }
                        paypalEnv={ paypalEnv }
                    />
                </Elements>
            </StripeProvider>
        );
    }
}

export function mapStateToProps(state) {
    const {
        paymentForm: {
            errors,
            paymentMethod,
            cardInformation,
            paypalId,
            stripePaymentProvider,
            showLoading
        },
        billingAddressForm,
        thinking
    } = state;

    return {
        thinking,
        showLoading,
        errors,
        paymentMethod,
        cardInformation,
        paypalId,
        stripePaymentProvider,
        country: billingAddressForm.country || state.country
    };
}

export function mapDispatchToProps(dispatch, { onPaymentRequestSubmit, onPaypalSubmit, onInteract = () => {} }) {
    return {
        onStripeError(source, error) {
            onInteract();

            if (!error) {
                return dispatch(paymentFormActions.clearError(source));
            }

            dispatch(paymentFormActions.showError({ type: source, message: error.message }));
        },

        setPaymentMethod(paymentMethod) {
            dispatch(paymentFormActions.updatePaymentMethod(paymentMethod));
        },

        setStripeProvider(stripe) {
            dispatch(paymentFormActions.setStripeProvider(stripe));
        },

        setStripePaymentProvider(stripePaymentProvider) {
            dispatch(paymentFormActions.setStripePaymentProvider(stripePaymentProvider));
        },

        onPaymentRequestSubmit(token, complete) {
            complete("success");

            onPaymentRequestSubmit(token);

            onInteract();
        },

        onPaypalSubmit(paypalInfo) {
            dispatch(paymentFormActions.updatePaymentMethod(PAYMENT_METHODS.PAYPAL));

            onPaypalSubmit(paypalInfo);

            onInteract();
        },

        onChangePaymentMethod(paymentMethod) {
            dispatch(paymentFormActions.updatePaymentMethod(paymentMethod));
            dispatch(paymentFormActions.clearCardInformation());
            dispatch(paymentFormActions.clearPayPalInformation());

            onInteract();
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentFormContainer);
